// extracted by mini-css-extract-plugin
export default {"filled":"icons_filled__U3X--"};